(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["leo-futterrechner"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('leo-feed-calculator')) return;

    class LeoFeedCalculator extends HTMLElement {
      connectedCallback() {
        queueMicrotask(() => {
          if (!this.isConnected || this._controller) return;
          this.init();
        });
      }

      disconnectedCallback() {
        if (this._controller) this._controller.abort();
        this._controller = null;
      }

      init() {
        this._controller = new AbortController();

        this.form = this.querySelector('[data-leo-form]');
        this.message = this.querySelector('[data-leo-message]');
        this.result = this.querySelector('[data-leo-result]');

        try {
          this.rules = JSON.parse(
            this.querySelector('[data-leo-rules]').textContent
          );

          if (!this.rules.wet || !this.rules.dry) {
            throw new Error('Missing food rules');
          }
        } catch (error) {
          this.showMessage(
            'Der Futterrechner ist gerade nicht verf\u00fcgbar. Bitte kontaktiere uns zur F\u00fctterung.',
            true
          );

          if (window.Shopify && window.Shopify.designMode) {
            console.error(
              'LEO Futterrechner: Regeln pr\u00fcfen.',
              error
            );
          }

          return;
        }

        this.food = this.querySelector('[data-leo-food]');
        this.stage = this.querySelector('[data-leo-stage]');
        this.weight = this.querySelector('[data-leo-weight]');
        this.age = this.querySelector('[data-leo-age]');
        this.activity = this.querySelector('[data-leo-activity]');

        this.isLive = this.dataset.live === 'true';

        this.form.hidden = false;

        this.syncFields();

        const options = {
          signal: this._controller.signal
        };

        this.form.addEventListener(
          'submit',
          (event) => {
            event.preventDefault();
            this.calculate();
          },
          options
        );

        this.form.addEventListener(
          'input',
          () => this.onInput(),
          options
        );

        this.form.addEventListener(
          'change',
          () => this.onInput(),
          options
        );
      }

      syncFields() {
        const growing = this.stage.value === 'growing';

        this.querySelector('[data-leo-age-wrap]').hidden = !growing;

        this.age.disabled = !growing;
        this.age.required = growing;
      }

      onInput() {
        this.syncFields();
        this.clearOutput();
      }

      clearOutput() {
        this.result.hidden = true;

        this.message.hidden = true;
        this.message.textContent = '';

        const advice = this.querySelector('[data-leo-advice]');

        if (advice) {
          advice.hidden = true;
        }

        this.form
          .querySelectorAll('[aria-invalid]')
          .forEach((field) => {
            field.removeAttribute('aria-invalid');
          });
      }

      showMessage(text, showAdvice = false, field = null) {
        this.message.textContent = text;
        this.message.hidden = false;

        const advice = this.querySelector('[data-leo-advice]');

        if (advice) {
          advice.hidden = !showAdvice;
        }

        if (field) {
          field.setAttribute('aria-invalid', 'true');
          field.focus();
        }
      }

      parseDecimal(value) {
        const cleaned = String(value).trim();

        if (!/^(?:\d+(?:[.,]\d+)?|[.,]\d+)$/.test(cleaned)) {
          return NaN;
        }

        return Number(cleaned.replace(',', '.'));
      }

      formatRange(low, high, unit, digits = 0) {
        const formatter = new Intl.NumberFormat('de-AT', {
          maximumFractionDigits: digits
        });

        const a = formatter.format(low);
        const b = formatter.format(high);

        return a === b
          ? `${a} ${unit}`
          : `${a}\u2013${b} ${unit}`;
      }

      calculate() {
        this.clearOutput();

        const weight = this.parseDecimal(this.weight.value);

        if (
          !Number.isFinite(weight) ||
          weight < 0.1 ||
          weight > 150
        ) {
          this.showMessage(
            'Bitte gib ein aktuelles Gewicht zwischen 0,1 und 150 kg ein, zum Beispiel 10,5.',
            false,
            this.weight
          );

          return;
        }

        const foodRule = this.rules[this.food.value];

        if (!foodRule) {
          this.showMessage(
            'F\u00fcr diese Futterart ist keine Berechnung hinterlegt.',
            true
          );

          return;
        }

        const activityKey =
          this.activity.value === 'high'
            ? 'high'
            : 'normal';

        let percentage =
          foodRule.adult[activityKey];

        if (this.stage.value === 'growing') {
          const ageText =
            String(this.age.value).trim();

          const age =
            /^\d+$/.test(ageText)
              ? Number(ageText)
              : NaN;

          if (
            !Number.isSafeInteger(age) ||
            age < 0 ||
            age > 156
          ) {
            this.showMessage(
              'Bitte gib das Alter in ganzen, vollendeten Wochen ein, zum Beispiel 20.',
              false,
              this.age
            );

            return;
          }

          if (age < 8) {
            this.showMessage(
              'F\u00fcr Welpen unter 8 Wochen ist in diesem Rechner keine Futtermenge hinterlegt. Bitte lass dich individuell beraten.',
              true
            );

            return;
          }

          const matches =
            (
              Array.isArray(foodRule.growing)
                ? foodRule.growing
                : []
            ).filter(
              (rule) =>
                age >= rule.min &&
                age <= rule.max
            );

          if (matches.length !== 1) {
            this.showMessage(
              'F\u00fcr dieses Alter ist keine eindeutige Berechnung hinterlegt. Bitte kontaktiere uns.',
              true
            );

            return;
          }

          percentage =
            matches[0][activityKey];
        }

        if (
          !Array.isArray(percentage) ||
          percentage.length !== 2 ||
          !percentage.every(
            (value) =>
              Number.isFinite(value) &&
              value > 0 &&
              value <= 20
          ) ||
          percentage[0] > percentage[1]
        ) {
          this.showMessage(
            'F\u00fcr diese Auswahl fehlt eine g\u00fcltige F\u00fctterungsregel. Bitte kontaktiere uns.',
            true
          );

          return;
        }

        const gramsLow =
          weight * 10 * percentage[0];

        const gramsHigh =
          weight * 10 * percentage[1];

        const dry =
          this.food.value === 'dry';

        this.querySelector(
          '[data-leo-result-title]'
        ).textContent =
          this.isLive
            ? 'Dein Orientierungswert'
            : 'Testberechnung \u2013 keine F\u00fctterungsempfehlung';

        this.querySelector(
          '[data-leo-daily-label]'
        ).textContent =
          dry
            ? 'Pro Tag, trocken abgewogen'
            : 'Pro Tag';

        this.querySelector(
          '[data-leo-daily]'
        ).textContent =
          `ca. ${this.formatRange(
            gramsLow,
            gramsHigh,
            'g'
          )}`;

        this.querySelector(
          '[data-leo-weekly]'
        ).textContent =
          this.formatRange(
            gramsLow * 7 / 1000,
            gramsHigh * 7 / 1000,
            'kg',
            2
          );

        this.querySelector(
          '[data-leo-weekly-wrap]'
        ).hidden =
          this.dataset.showWeekly !== 'true';

        const activityText =
          this.activity.value === 'high'
            ? ' Erh\u00f6hter Orientierungswert f\u00fcr intensiven Jagd-, Arbeits- oder Sporteinsatz.'
            : '';

        const basisText =
          dry
            ? `Berechnungsbasis: ${this.formatRange(
                percentage[0] * 10,
                percentage[1] * 10,
                'g/kg',
                2
              )} aktuelles K\u00f6rpergewicht.`
            : `Berechnungsbasis: ${this.formatRange(
                percentage[0],
                percentage[1],
                '%',
                2
              )} des aktuellen K\u00f6rpergewichts (${this.formatRange(
                weight,
                weight,
                'kg',
                2
              )}).`;

        this.querySelector(
          '[data-leo-basis]'
        ).textContent =
          `${basisText}${activityText}`;

        this.querySelector(
          '[data-leo-preparation]'
        ).textContent =
          dry
            ? 'Die Grammangabe bezieht sich auf Trockenbarf VOR dem Einweichen. Wasser ist nicht mitgerechnet. Zubereitung und erforderliche Erg\u00e4nzungen laut Produktangaben beachten.'
            : 'Die Grammangabe ist die gesamte Tagesmenge des Tiefk\u00fchl-Men\u00fcs, nicht die Menge pro Mahlzeit. F\u00fctterungshinweise und erforderliche Erg\u00e4nzungen der jeweiligen Rezeptur beachten.';

        const wetLink =
          this.querySelector('[data-leo-wet-link]');

        const dryLink =
          this.querySelector('[data-leo-dry-link]');

        const roll =
          this.querySelector('[data-leo-roll]');

        if (wetLink) {
          wetLink.hidden = dry;
        }

        if (dryLink) {
          dryLink.hidden = !dry;
        }

        if (roll) {
          roll.hidden =
            dry ||
            gramsHigh < 800;
        }

        this.result.hidden = false;

        this.result.focus({
          preventScroll: true
        });
      }
    }

    customElements.define(
      'leo-feed-calculator',
      LeoFeedCalculator
    );
  })();

  } catch(e) { console.error(e); }
})();
})();
